module.exports = __webpack_public_path__ + "img/white-check.5c5ff080.svg";